import { Component, OnInit } from '@angular/core';
import { ValidateJWTRequest } from '../store/auth.actions';
import { select, Store } from '@ngrx/store';
import { selectAuthClaims } from '../store/auth.store';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthState } from '../store/auth.state';
import { isArray, isObject } from 'lodash-es';

@Component({
    selector: 'q-auth-page',
    templateUrl: `./auth-page.component.html`,
    styles: ['']
})
export class AuthPageComponent implements OnInit {
    private redirect: string = '/';
    public framed: boolean = false;

    constructor(
        private store: Store<AuthState>,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.route.queryParams.subscribe(params => {
            this.redirect = params['qmReturnUrl']
                ? params['qmReturnUrl']
                : this.redirect;
            this.framed = params['framed'] === 'true';
        });
    }

    ngOnInit() {
        this.store.dispatch(new ValidateJWTRequest());
        this.store
            .pipe(
                select(selectAuthClaims),
                filter(
                    claims =>
                        isObject(claims) && isArray(claims.enabled_sso_apps)
                )
            )
            .subscribe(claims => {
                /* replaceUrl => When true, navigates while replacing the current state in history. */
                /* Solves the problem of multiple back clicks to reach intended landing page,
                    by not adding "/events" to browser history and replacing it with the child navigation
                    url, i.e. "/events/list". */
                this.router.navigate([this.redirect], {
                    replaceUrl: true
                });
            });
    }
}
